import * as React from 'react';

import {FieldWithIcon} from 'shells/field-with-icon/field-with-icon';
import {FormattedNumberField} from 'shells/formatted-number-field/formatted-number-field';
// @ts-expect-error - imported from .js/.jsx file
import {RevenueIcon} from 'shells/icon/svg/revenue-icon';

export const REVENUE_INPUT_FIELD_ID = 'revenue-input-field';

type Props = {
    revenue: number | null | undefined;
    onUpdateAccountRevenue: (revenue?: number | null | undefined) => void;
    isDisabled?: boolean;
};

export function AccountRevenueField(props: Props) {
    const {revenue, onUpdateAccountRevenue, isDisabled} = props;

    const [revenueInput, setRevenueInput] = React.useState<number | null | undefined>(revenue);

    const onSaveRevenueInput = () => {
        if (isDisabled || revenue === revenueInput) return;

        onUpdateAccountRevenue(revenueInput);
    };

    React.useEffect(() => {
        setRevenueInput(revenue);
    }, [revenue]);

    return (
        <FieldWithIcon icon={RevenueIcon}>
            <FormattedNumberField
                formatType='currency'
                // @ts-expect-error
                size='small'
                placeholder='00.00'
                id={REVENUE_INPUT_FIELD_ID}
                value={revenueInput}
                onChange={setRevenueInput}
                onEnter={onSaveRevenueInput}
                onBlur={onSaveRevenueInput}
                clearable={true}
                disabled={isDisabled}
            />
        </FieldWithIcon>
    );
}
